<div class="conn-card">
    <app-report-top-filter-bar
        [paraReportName]="'department-sales-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        >
    </app-report-top-filter-bar>

    <p-table [value]="dataList" dataKey="name" #dt [columns]="csvcols" styleClass="p-datatable-striped" [tableStyle]="{'table-layout':'fixed'}" *ngIf="dataList?.length > 0">
        <ng-template pTemplate="colgroup">
            <colgroup>
                <col style="width: 30%" />
                <col style="width: 23%" />
                <col style="width: 23%" />
                <col style="width: 24%" />
            </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="vertical-align: middle" [style.text-align]="first ? 'left' : 'right'" *ngFor="let col of domColHeader; let first = first">
                    <strong>{{col}}</strong>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td style="text-align: left; vertical-align: middle">{{product.groupValue }}</td>
                <td style="text-align: right; vertical-align: middle">{{ product.totalSales | currency | currencySpacing }}</td>
                <td style="text-align: right; vertical-align: middle">{{ product.invoiceCount | number }}</td>
                <td style="text-align: right; vertical-align: middle">{{ product.totalProfit | currency | currencySpacing }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr *ngIf="dataList?.length > 0">
                <td style="text-align: left; vertical-align: middle"><strong>Total</strong></td>
                <td *ngFor="let col of domSummaryflds" style="text-align: right; vertical-align: middle">{{calculateSummaryTotal(col)}}</td>
            </tr>
        </ng-template>
    </p-table>
    
    <div class="flex" *ngIf="dataList?.length==0">
        <div class="flex justify-content-center" style="width: 100%">
            <span class="control-description text-muted text-align-center"> No data found!</span>
        </div>
    </div>
</div>